import React from "react";
import styles from './DSGNavigation.module.css';

export default function DSGNavigation({ currentPage, navigateToPage, totalPages, alert, top }) {

  const handlePrevClick = () => {
    if (currentPage > 0) {
      navigateToPage(currentPage - 1);
    }
  }

  const handleNextClick = () => {
    if (currentPage < totalPages + 2) {
      navigateToPage(currentPage + 1);
    }
  }

  // Hide nav buttons on first page for the top navigation
  if (top && currentPage === 0) {
    return (
      <div className={styles.navContainer}>
        {alert ? <div className="alert">{alert}</div> : null}
      </div>
    );
  }

  return (
    <div className={styles.navContainer}>
      {currentPage > 0 ?
        <button onClick={handlePrevClick} className={styles.navButton}>Zurück</button> :
        <button className={styles.navButton} style={{ visibility: "hidden" }}>Zurück</button>
      }
      {alert ? <div className="alert">{alert}</div> : null}
      {currentPage < totalPages + 2 ?
        <button onClick={handleNextClick} className={styles.navButton}>Weiter</button> :
        <button className={styles.navButton} style={{ visibility: "hidden" }}>Weiter</button>
      }
    </div>
  );
}
